var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState, } from 'react';
import { Typeahead, } from '../Typeahead/index';
import { MapService, } from './MapService';
const AutocompleteAddress = (_a) => {
    var { callbackOnFetch, handleSuggestionSelection, mapModule, mapServiceOptions, name, onChange, onUpdate } = _a, otherProps = __rest(_a, ["callbackOnFetch", "handleSuggestionSelection", "mapModule", "mapServiceOptions", "name", "onChange", "onUpdate"]);
    const [suggestions, setSuggestions,] = useState([]);
    const mapService = useMemo(() => (new MapService(mapModule, mapServiceOptions)), [
        mapModule,
        mapServiceOptions,
    ]);
    const suggestionLabels = useMemo(() => (suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((suggestion) => (mapService.getSuggestionLabel(suggestion)))), [
        mapService,
        suggestions,
    ]);
    const onTypeaheadChange = useCallback(async (event) => {
        const inputValue = event.target.value;
        if (onChange) {
            onChange(event);
        }
        if (onUpdate) {
            onUpdate({
                payload: inputValue,
                type: 'input_change',
            });
        }
        const mapSuggestions = await mapService.search(inputValue);
        setSuggestions(mapSuggestions);
        if (callbackOnFetch) {
            callbackOnFetch(mapSuggestions);
        }
        if (onUpdate) {
            onUpdate({
                payload: mapSuggestions,
                type: 'suggestions_change',
            });
        }
    }, [
        callbackOnFetch,
        mapService,
        onUpdate,
        onChange,
        setSuggestions,
    ]);
    const onTypeaheadSelect = useCallback((selectedLabel) => {
        const selectedSuggestion = (suggestions === null || suggestions === void 0 ? void 0 : suggestions.find((suggestion) => (mapService.getSuggestionLabel(suggestion) === selectedLabel)));
        if (handleSuggestionSelection) {
            handleSuggestionSelection(selectedSuggestion);
        }
        if (onUpdate) {
            onUpdate({
                payload: selectedSuggestion,
                type: 'suggestions_select',
            });
        }
        if (!handleSuggestionSelection && onChange) {
            const FAKE_changeEvent = {
                target: {
                    name,
                    value: selectedLabel,
                },
            };
            onChange(FAKE_changeEvent);
        }
    }, [
        handleSuggestionSelection,
        mapService,
        name,
        onUpdate,
        onChange,
        suggestions,
    ]);
    const typeaheadProps = Object.assign(Object.assign({}, otherProps), { name,
        onChange });
    return (_jsx(Typeahead, Object.assign({}, typeaheadProps, { id: name, items: suggestionLabels, name: name, onChange: onTypeaheadChange, onSelect: onTypeaheadSelect })));
};
export { AutocompleteAddress };
